// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__jauxq","inner":"Footer_inner__AYeHk"};